// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1nfvA","productName":"Table_productName__2lvQT"};